import { useEffect, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'

import type { Seminar } from 'services/seminars/types'
import type { Props } from 'services/content/components/types/FindACourseModule'
import fetchFindACourse from 'services/seminars/fetchFindACourse'
import { getUserCountry } from 'store/user/selectors'
import { getTrainingLanguageStrings } from 'store/strings/selectors'
import FindACourse from 'ui-component-library/components/FindACourse'

function FindACourseContainer({ ...props }: Props) {
  const userCountry = useSelector(getUserCountry)
  const languageStrings = useSelector(getTrainingLanguageStrings)

  const [isLoading, setIsLoading] = useState(true)
  const [seminars, setSeminars] = useState<Seminar[]>([])
  const [selectedCountry, setSelectedCountry] = useState('')
  const [params, setParams] = useState({
    country: userCountry,
    date: '6m',
    stateProvince: '',
    course: '',
    language: '',
  })

  useEffect(() => {
    async function fetch() {
      setIsLoading(true)
      const { results, country } = await fetchFindACourse(params)
      setSeminars(results)
      setSelectedCountry(country)
      setIsLoading(false)
    }

    fetch()
  }, [params.date, params.country, params.language])

  function handleChangeFilter(field: string, value: string) {
    setParams((currentParams) => ({
      ...currentParams,
      [field]: value,
    }))
  }

  const filteredSeminars = useMemo(() => {
    return seminars.filter((seminar) => {
      if (!seminar.isOpen) {
        return false
      }

      if (
        params.stateProvince !== '' &&
        seminar.state !== params.stateProvince
      ) {
        return false
      }

      if (params.course !== '' && seminar.metaType !== params.course) {
        return false
      }

      return true
    })
  }, [seminars, params])

  return (
    <FindACourse
      {...props}
      languageStrings={languageStrings}
      seminars={filteredSeminars}
      onChangeFilter={handleChangeFilter}
      isLoading={isLoading}
      params={params}
      selectedCountry={selectedCountry}
    />
  )
}

export default FindACourseContainer
